// extracted by mini-css-extract-plugin
module.exports = {"bf-banner":"_93444fe79c--bf-banner--ewQw4","title":"_93444fe79c--title--cy7gc","subtitle":"_93444fe79c--subtitle--ykFMP"};